import { render, staticRenderFns } from "./Particularites.vue?vue&type=template&id=0b708732&"
import script from "./Particularites.vue?vue&type=script&lang=js&"
export * from "./Particularites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports